import { api } from '@/lib/api';
import type {
  ListSuggestedFilters,
  SuggestedOpportunity,
  SuggestedStats,
} from '../types/suggested-opportunities.types';

const BASE = '/tm/auto-sourcing/suggestions';

/**
 * Sprint 5b.1.5 v2 — Client API « Opportunités suggérées ».
 */
export const suggestedOpportunitiesService = {
  async list(filters: ListSuggestedFilters = {}): Promise<SuggestedOpportunity[]> {
    const params = buildQueryParams(filters);
    const { data } = await api.get<SuggestedOpportunity[]>(BASE, { params });
    return data;
  },

  async stats(filters: ListSuggestedFilters = {}): Promise<SuggestedStats> {
    const params = buildQueryParams(filters);
    const { data } = await api.get<SuggestedStats>(`${BASE}/stats`, { params });
    return data;
  },

  async recompute(): Promise<{ status: string }> {
    const { data } = await api.post<{ status: string }>(`${BASE}/recompute`);
    return data;
  },
};

function buildQueryParams(filters: ListSuggestedFilters): Record<string, unknown> {
  const params: Record<string, unknown> = {};
  if (filters.minScore !== undefined) params.minScore = filters.minScore;
  if (filters.departements && filters.departements.length > 0)
    params.departements = filters.departements.join(',');
  if (filters.minAmount !== undefined) params.minAmount = filters.minAmount;
  if (filters.maxAmount !== undefined) params.maxAmount = filters.maxAmount;
  if (filters.marketTypes && filters.marketTypes.length > 0)
    params.marketTypes = filters.marketTypes.join(',');
  if (filters.sources && filters.sources.length > 0)
    params.sources = filters.sources.join(',');
  if (filters.sortBy) params.sortBy = filters.sortBy;
  if (filters.sortDir) params.sortDir = filters.sortDir;
  if (filters.page !== undefined) params.page = filters.page;
  if (filters.pageSize !== undefined) params.pageSize = filters.pageSize;
  if (filters.periodDays !== undefined) params.periodDays = filters.periodDays;
  return params;
}
